// extracted by mini-css-extract-plugin
export default {"title":"Yxzf6WN0GASwGI1GSQMr","message":"t3i5Le2k2FgV7en99ogB"};